import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';

const Header = ({ onNavigate }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header
      style={{
        background: 'rgba(255, 254, 249, 0.98)',
        borderBottom: '1px solid var(--border-gold)',
        padding: '20px 0',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)'
      }}
    >
      <div className="luxury-container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{
              fontSize: '22px',
              fontWeight: '600',
              fontFamily: 'Inter, -apple-system, sans-serif',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              letterSpacing: '-0.5px'
            }}
          >
            <span style={{ color: 'var(--accent-gold)' }}>Enliven</span> Elite Tax Pro
          </div>

          {/* Desktop Navigation */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: '32px' }} className="desktop-nav">
            <button
              onClick={() => scrollToSection('services')}
              className="btn-secondary"
              style={{ padding: '8px 0' }}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('appointments')}
              className="btn-secondary"
              style={{ padding: '8px 0' }}
            >
              Book Appointment
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-secondary"
              style={{ padding: '8px 0' }}
            >
              Contact
            </button>
            <a href="tel:800-426-0441" className="btn-primary" style={{ textDecoration: 'none', padding: '12px 24px', height: 'auto', minWidth: 'auto', fontSize: '13px' }}>
              <Phone size={14} />
              800-426-0441
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="mobile-menu-toggle"
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              color: 'var(--accent-gold)'
            }}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav
            className="mobile-nav"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              marginTop: '24px',
              paddingTop: '24px',
              borderTop: '2px solid var(--accent-gold)'
            }}
          >
            <button onClick={() => scrollToSection('services')} className="btn-secondary" style={{ textAlign: 'left' }}>
              Services
            </button>
            <button onClick={() => scrollToSection('appointments')} className="btn-secondary" style={{ textAlign: 'left' }}>
              Book Appointment
            </button>
            <button onClick={() => scrollToSection('contact')} className="btn-secondary" style={{ textAlign: 'left' }}>
              Contact
            </button>
            <a href="tel:800-426-0441" className="btn-primary" style={{ textDecoration: 'none', textAlign: 'center' }}>
              <Phone size={14} />
              800-426-0441
            </a>
          </nav>
        )}
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-toggle {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;